import React, {Component} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import constants from '../parameters/constants';

const ErrorContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 3px solid ${constants.secondaryColor2};
  background: ${constants.secondaryColor};
  z-index: 1000;
  color: white;
  padding: 10px 20px;
  font-size: 20px;
`;

class SuccessMessage extends Component {
  static state = {
    timeout: false
  };

  timeout = undefined;

  static propTypes = {
    messages: PropTypes.array,
    clearMessages: PropTypes.func.isRequired
  };

  clearTimeout = () => this.timeout && clearTimeout(this.timeout);

  componentWillReceiveProps(newProps) {
    if (newProps.messages && newProps.messages.length > 0) {
      this.clearTimeout();
      this.timeout = setTimeout(() => {
        this.props.clearMessages();
      }, 4000);
    }
  }

  componentWillUnmount() {
    this.clearTimeout();
  }

  render() {
    const {messages} = this.props;
    if (!messages || messages.length === 0) {
      return null;
    }
    return (
      <ErrorContainer>
        {messages.map((m, i) => {
          const message = m.message || m;
          return (
            <div key={'message_' + i}>
              {message}
            </div>
          );
        })}
      </ErrorContainer>
    );
  }
}

export default SuccessMessage;



// WEBPACK FOOTER //
// ./src/components/SuccessMessage.js